module.exports = __webpack_public_path__ + "static/img/7.f6b6276.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/7.png
// module id = Fufd
// module chunks = 4